export function validateEmail(email) {
	// 'anystring@anystring.anystring' (whitespace not allowed)
	return /^\S+@\S+\.\S+$/.test(email)
}
